import Home from "../components/Home/Home";

const Homepage = () => <Home />;

export default Homepage;
